export {default} from './NumericData';
